module.exports = __webpack_public_path__ + "static/media/logo.693690bb.svg";